import { render, staticRenderFns } from "./OkConfirmDialog.vue?vue&type=template&id=aa66cc6c&scoped=true&"
import script from "./OkConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./OkConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./OkConfirmDialog.vue?vue&type=style&index=0&id=aa66cc6c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa66cc6c",
  null
  
)

export default component.exports